//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      isExpand: false,
      currentStep: '01'
    }
  },
  created () {
    this.$vux.loading.hide()
  },
  methods: {
    onChange: function (index) {
      this.currentStep = '0' + (Number(index) + 1)
    },
    leftClick: function (event) {
      this.$refs['vanswipe'].swipeTo(Number(this.currentStep - 2))
    },
    rightClick: function (event) {
      this.$refs['vanswipe'].swipeTo(Number(this.currentStep))
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Guide/confirmGuide.vue